<template>
  <section id="contact">
    <cloud-background
      :elements="elements"
      height=150>
    </cloud-background>
    <img src="../assets/rainbow.svg" class="footer-rainbow">
    <div class="contact">
      <br />
      <custom-title text="Contact Us" header-class="contact-title" text-colour="white" stripe-colour="#A2D4C1"></custom-title>
      <br />
      <p>For general enquiries please contact support [at] unicorn.global</p>
      <div class="contact-footer">
        &copy; 2017-{{ (new Date()).getFullYear() }}&nbsp; Unicorn Global |&nbsp;<a class="terms" href="https://github.com/UnicornGlobal/unicorn-terms-and-conditions" target="_blank">Terms &amp; Conditions</a>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  .terms {
    color: white;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .contact-footer {
    width: 100%;
    height: 90px;
    min-height: 50px;
    background: #171544;
    color: white;
    border-radius: 100% 100% 0 0;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
  }

  .footer-rainbow {
    height: 18vh;
    position: relative;
    margin-top: -4vh;
    top: 0;
    @media (max-height: 380px) {
      top: 2em;
    }
    @media (max-height: 480px) and (min-height: 381px) {
      top: 1em;
    }
  }

  .contact {
    min-height: 350px;
    /* height: 70vh; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-image: url('../assets/contact-world.svg');
    background-size: cover;
    background-position: 50% 0;
    margin-top: -16vh;
    padding-top: 7%;
    position: relative;
  }

  @media (min-width: 1000px) {
    .contact {
      margin-top: -18vh;
    }
  }

  @media (min-width: 1200px) {
    .contact {
      margin-top: -19vh;
    }
  }

  @media (min-width: 1400px) {
    .contact {
      margin-top: -19vh;
    }
  }

  @media (min-width: 1600px) {
    .contact {
      margin-top: -22vh;
    }
  }

  p {
    max-width: 80%;
    width: 600px;
    margin: 2rem auto;
    color: white;
    font-size: 1.1rem;
    text-align: center;
    flex: 1;
  }

  b {
    color: white;
  }
</style>

<script>
import CloudOne from './CloudBackground/CloudOne'
import CloudTwo from './CloudBackground/CloudTwo'
import CloudThree from './CloudBackground/CloudThree'
import CloudBackground from './CloudBackground/CloudBackground'
import CustomTitle from './CustomTitle'

export default {
  components: {
    CloudBackground,
    CustomTitle
  },
  data () {
    return {
      elements: [
        CloudOne,
        CloudTwo,
        CloudThree
      ]
    }
  }
}
</script>
